import { createRoutes } from 'shared/hocs'

import { EventsOverview } from './overview'
import { EventAdd } from './add'

export const Events = createRoutes(({ match }) => [
  {
    path: `${match.path}/add`,
    component: EventAdd,
  },
  {
    exact: true,
    path: match.path,
    component: EventsOverview,
  },
])
